import React from "react";
import { useSearchParams } from "react-router";
import Header from "@/components/common/header/DefaultHeader";
import MobileMenu from "@/components/common/header/MobileMenu";
import MetaComponent from "@/components/common/MetaComponent";
import BidDepositCharge from "@/components/bid-deposit-charge/BidDepositCharge";

const metadata = {
  title: "Hubzu | Bid Deposit Charge",
};

const BidDepositChargeScreen = () => {
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get('propId');

  return (
    <div>
      <Header />
      <MobileMenu />
      <MetaComponent meta={metadata} />
      <BidDepositCharge propertyId={propertyId} />
    </div>
  );
};

export default BidDepositChargeScreen;
